import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/Sidebar'
import { AppHeader } from '@/components/AppHeader'
import { TermsAcceptanceGate } from '@/components/TermsAcceptanceGate'
import { MobileSidebarProvider } from '@/contexts/MobileSidebarContext'
import { useAuth } from '@/hooks/useAuth'
import { useMobileSidebar } from '@/hooks/useMobileSidebar'
import styles from './AppLayout.module.css'

function AppLayoutShell() {
  const { isOpen, close } = useMobileSidebar()

  return (
    <div className={styles.wrapper}>
      <div
        className={[styles.backdrop, isOpen && styles.backdropVisible]
          .filter(Boolean)
          .join(' ')}
        aria-hidden={!isOpen}
        onClick={close}
      />
      <Sidebar />
      <div className={styles.content}>
        <AppHeader />
        <main className={`${styles.main} appMain`}>
          <div className="appContentShell">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export function AppLayout() {
  const { guard } = useAuth()

  const layout = (
    <MobileSidebarProvider>
      <AppLayoutShell />
    </MobileSidebarProvider>
  )

  if (guard === 'institution') {
    return <TermsAcceptanceGate>{layout}</TermsAcceptanceGate>
  }

  return layout
}
